import {useEffect} from 'react';


const PageTitle = ({title}: { title: string }) => {
    useEffect(() => {
        if (title) {
            document.title = `${title} | DCGP`;
        }
    }, [title]);

    return null;
};

export default PageTitle;
